import { ServerError } from '../common';

export const isServerError = (obj: unknown): obj is ServerError => {
  return (obj as ServerError).message !== undefined;
};
